@if (application().czyJednostkaWojewodzka()) {
  <div class="infoMessagePadding">
    <app-info-message
      [label]="'Wskaż z listy województwo, w którym znajduje się urząd lub instytucja, do którego składasz wniosek.'"
    ></app-info-message>
  </div>
  <div class="flex gap-2">
    <p-select
      id="voivodeship"
      inputId="voivodeship"
      [pAutoFocus]="true"
      [options]="voivodeshipList()"
      [emptyMessage]="'Brak rekordów do wyświetlenia.'"
      (onChange)="onFilterWojewodztwa($event)"
      appControlError
      optionLabel="nazwa"
      placeholder="Wybierz województwo"
      class="w-full"
      appendTo="body"
    />
  </div>
} @else {
  <div class="infoMessagePadding">
    <app-info-message [labelHTML]="'searchJednostka.info'"></app-info-message>
  </div>
  <label for="filter">Jednostka</label>
  <div class="flex gap-2">
    <input
      id="filter"
      [pAutoFocus]="true"
      [(ngModel)]="filter"
      (keydown.enter)="onFilterGminy()"
      class="w-full"
      pInputText
      placeholder="Wpisz przynajmniej 3 znaki"
      appControlError
    />

    <div class="flex items-center gap-2">
      <p-button
        [label]="'Szukaj'"
        [disabled]="this.filter().length < 3"
        (click)="onFilterGminy()"
        styleClass="customInfoButton"
        size="small"
      ></p-button>

      <p-button
        [label]="'Wyczyść'"
        (click)="resetFilter()"
        styleClass="customInfoButton outlined"
        size="small"
      ></p-button>
    </div>
  </div>
}
<hr class="mt-2" />
<div class="jednostkaList">
  <p-table
    [value]="rows()"
    [loading]="dataLoading()"
    [scrollable]="false"
    selectionMode="single"
    stripedRows
    (onRowSelect)="onRowSelect($event)"
    dataKey="kod"
  >
    <ng-template #header>
      <tr>
        <td style="width: 4rem"></td>
        <th style="width: 60%">Opis jednostki</th>
        <th style="width: 40%">Lokalizacja</th>
      </tr>
    </ng-template>
    <ng-template #body let-urzad>
      <tr [pSelectableRow]="urzad" tabindex="0">
        <td>
          <p-radio-button
            name="selectItem"
            class="customRadioButton"
            [value]="urzad"
            [(ngModel)]="selectedItem"
          >
          </p-radio-button>
        </td>
        <td tabindex="0">{{ urzad.nazwa }}</td>
        <td tabindex="0">{{ urzad.adres }}</td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="3" class="text-center p-4">
          @if (this.hasActiveSearch()) {
            Brak rekordów do wyświetlenia.
          } @else {
            {{
              application().czyJednostkaWojewodzka()
                ? 'W celu wyszukania jednostki wybierz województwo z listy.'
                : 'W celu wyszukania urzędu lub instytucji podaj nazwę miejscowości.'
            }}
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div class="flex justify-end unit-choose-actions">
  <p-button
    styleClass="customInfoButton"
    size="small"
    [label]="'Wybierz'"
    [disabled]="!selectedItem()"
    (click)="emitSelectedApplication()"
  ></p-button>
</div>
